import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';
import { Link } from 'react-router-dom';

function BikeRentals() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <div className="mt-16 md:mt-24 py-12 md:py-16 bg-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <h1 className="text-4xl md:text-6xl text-center uppercase italic tracking-[0.2em] md:tracking-[0.3em] mb-12 md:mb-16 font-light">
            BIKE RENTALS
          </h1>

          {/* Content Section */}
          <div className="space-y-6 text-gray-800 leading-relaxed">
            <p>
              Throttle Edge rents out a variety of models for recreational riding on all our tracks and 3 trail systems. You must have riding experience, and/or have completed one of our red rider courses previously. Anyone under the age of 18 MUST be accompanied by an adult.
            </p>

            <p>
              To ensure the integrity of our equipment and facilitate a seamless rental process, we kindly request a credit card hold for bike rentals. This measure serves to cover any potential damages incurred during the rental period.
            </p>

            <p>
              Renters are accountable for any damages, including but not limited to bent or broken bars, levers, perches, cracked or broken plastic, and ripped seat covers, and are expected to cover associated repair or replacement costs.
            </p>

            <p>
              Throttle Edge Inc staff reserve the right to evaluate your riding ability when assigning you to a bike.
            </p>

            <p className="font-bold">
              All bike rentals include track/trail passes along will full safety equipment
            </p>

            <p>
              Visit our <Link to="/park-rules" className="text-blue-600 hover:underline italic">'Park Info/Rules'</Link> page to read over all rules and regulations prior to lessons and rentals.
            </p>

            <p className="font-bold text-lg" style={{ color: '#F5A623' }}>
              For Bookings: <a href="mailto:bookings@throttledge.com" className="text-red-600 hover:underline">bookings@throttledge.com</a>
            </p>

            <p className="font-bold text-red-600">
              Holiday Early Bird: Use code CHRISTMAS10 for 10% off until Christmas!
            </p>
          </div>

          {/* Bike Models Section */}
          <div className="mt-12 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            {/* CRF50F */}
            <div className="text-center">
              <img 
                src="/bike1.webp" 
                alt="CRF50F" 
                className="w-full h-64 object-contain mb-6 bg-white"
              />
              <h2 className="text-3xl font-bold mb-6 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                CRF50F
              </h2>
              <div className="space-y-3 text-gray-800 mb-6">
                <p className="font-semibold">2 Hours: PKR 33,741 + HST</p>
                <p className="font-semibold">Full Day: PKR 61,893 + HST</p>
              </div>
              <button className="border-2 border-black text-black px-12 py-3 hover:bg-black hover:text-white transition-colors uppercase text-xs font-bold tracking-widest">
                BOOK NOW
              </button>
            </div>

            {/* CRF110F */}
            <div className="text-center">
              <img 
                src="/bike2.webp" 
                alt="CRF110F" 
                className="w-full h-64 object-contain mb-6 bg-white"
              />
              <h2 className="text-3xl font-bold mb-6 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                CRF110F
              </h2>
              <div className="space-y-3 text-gray-800 mb-6">
                <p className="font-semibold">2 Hours: PKR 42,021 + HST</p>
                <p className="font-semibold">Full Day: PKR 72,243 + HST</p>
              </div>
              <button className="border-2 border-black text-black px-12 py-3 hover:bg-black hover:text-white transition-colors uppercase text-xs font-bold tracking-widest">
                BOOK NOW
              </button>
            </div>

            {/* CRF125F */}
            <div className="text-center">
              <img 
                src="/bike3.webp" 
                alt="CRF125F" 
                className="w-full h-64 object-contain mb-6 bg-white"
              />
              <h2 className="text-3xl font-bold mb-6 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                CRF50F
              </h2>
              <div className="space-y-3 text-gray-800 mb-6">
                <p className="font-semibold">2 Hours: PKR 42,021 + HST</p>
                <p className="font-semibold">Full Day: PKR 72,243 + HST</p>
              </div>
              <button className="border-2 border-black text-black px-12 py-3 hover:bg-black hover:text-white transition-colors uppercase text-xs font-bold tracking-widest">
                BOOK NOW
              </button>
            </div>

            {/* CRF150F */}
            <div className="text-center">
              <img 
                src="/bike4.webp" 
                alt="CRF110F" 
                className="w-full h-64 object-contain mb-6 bg-white"
              />
              <h2 className="text-3xl font-bold mb-6 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                CRF150F
              </h2>
              <div className="space-y-3 text-gray-800 mb-6">
                <p className="font-semibold">2 Hours: PKR 42,021 + HST</p>
                <p className="font-semibold">Full Day: PKR 72,243 + HST</p>
              </div>
              <button className="border-2 border-black text-black px-12 py-3 hover:bg-black hover:text-white transition-colors uppercase text-xs font-bold tracking-widest">
                BOOK NOW
              </button>
            </div>

            {/* CRF230F */}
            <div className="text-center">
              <img 
                src="/bike5.webp" 
                alt="CRF125F" 
                className="w-full h-64 object-contain mb-6 bg-white"
              />
              <h2 className="text-3xl font-bold mb-6 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                CRF125FB
              </h2>
              <div className="space-y-3 text-gray-800 mb-6">
                <p className="font-semibold">2 Hours: PKR 42,021 + HST</p>
                <p className="font-semibold">Full Day: PKR 72,243 + HST</p>
              </div>
              <button className="border-2 border-black text-black px-12 py-3 hover:bg-black hover:text-white transition-colors uppercase text-xs font-bold tracking-widest">
                BOOK NOW
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default BikeRentals;
